<template>
  <div class="header-wrapper header">
    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/rentals')"
    >
      <router-link
        class="headerBtn"
        to="/rentals/calendar"
        :class="{
          'route-active': this.$route.path.startsWith('/rentals/calendar')
        }"
      >
        <h4>Calendar</h4>
        <div class="headerBtnBottom" />
      </router-link>
      <router-link
        class="headerBtn"
        to="/rentals/list"
        :class="{
          'route-active': this.$route.path.startsWith('/rentals/list')
        }"
      >
        <h4>List</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="
        this.$route.path.startsWith('/listings') ||
        this.$route.path.startsWith('/rooms') ||
        this.$route.name == 'editProperty'
      "
    >
      <router-link
        class="headerBtn properties"
        to="/listings/properties"
        :class="{
          'route-active':
            this.$route.path.startsWith('/listings/properties') ||
            this.$route.name == 'editProperty'
        }"
      >
        <h4>Properties</h4>
        <div class="headerBtnBottom" />
      </router-link>
      <router-link
        class="headerBtn"
        to="/listings/rooms"
        :class="{
          'route-active':
            this.$route.path.startsWith('/listings/rooms') ||
            this.$route.path.startsWith('/rooms/new') ||
            this.$route.path.startsWith('/rooms/edit')
        }"
      >
        <h4>Rooms</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/chores')"
    >
      <router-link
        class="headerBtn chores"
        to="/chores/calendar"
        :class="{
          'route-active': this.$route.path.startsWith('/chores/calendar')
        }"
      >
        <h4>Calendar</h4>
        <div class="headerBtnBottom" />
      </router-link>
      <router-link
        class="headerBtn chores"
        to="/chores/list"
        :class="{
          'route-active': this.$route.path.startsWith('/chores/list')
        }"
      >
        <h4>Chores</h4>
        <div class="headerBtnBottom" />
      </router-link>
      <router-link
        class="headerBtn chores"
        to="/chores/notifications"
        :class="{
          'route-active':
            this.$route.path.startsWith('/chores/notifications') ||
            this.$route.name == 'NewNotificationScreen'
        }"
      >
        <h4>Notifications</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/report')"
    >
      <router-link
        class="headerBtn"
        to="/report"
        :class="{ 'route-active': this.$route.path.startsWith('/report') }"
      >
        <h4>Report</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/heatmap')"
    >
      <router-link
        class="headerBtn"
        to="/heatmap"
        :class="{ 'route-active': this.$route.path.startsWith('/heatmap') }"
      >
        <h4>Heatmap</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/contacts')"
    >
      <router-link
        class="headerBtn"
        to="/contacts/housemates"
        :class="{ 'route-active': this.$route.path.startsWith('/contacts') }"
      >
        <h4>Housemates</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/ai-agent')"
    >
      <router-link
        class="headerBtn"
        to="/ai-agent"
        :class="{ 'route-active': this.$route.path.startsWith('/ai-agent') }"
      >
        <h4>Messages</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <!-- this is to add whitespace in case you dont want to show navigation buttons -->
    <!-- <div 
        v-if="this.$route.name == 'editProperty'"
        class="header-white-space"
      /> -->

    <div v-if="!smallDevice" class="header-actions">
      <button
        v-if="this.$route.path.startsWith('/ai-agent')"
        class="ask-ai-button"
        type="button"
      >
        <span>&#10022;</span>
        Ask AI
      </button>

      <div class="headerUserContainer">
        <img
          v-if="user && user.photoURL"
          alt="User Icon"
          :src="user.photoURL"
          class="accountImage"
        />
        <div class="headerUserDataContainer">
          <div class="headerUserName" v-if="user">
            {{ user.displayName }}
          </div>
          <div class="headerUserEmail" v-if="user">
            {{ user.email }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from './../Firebase'

export default {
  name: 'Header',
  data() {
    return {
      user: null,
      smallDevice: false
    }
  },
  created() {
    this.getUserData()
    window.addEventListener('resize', this.onResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    getUserData() {
      auth.onAuthStateChanged((user) => {
        this.user = user
      })
    },

    onResize() {
      this.width = window.innerWidth
      if (this.width > 768) {
        this.smallDevice = false
      } else {
        this.smallDevice = true
      }
    }
  }
}
</script>

<style scoped>
.header-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 24px 26px 0 0;
  min-height: 46px;
  background-color: #ffffff;
}
.headerBtnContainer {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-right: 25px;
  padding-left: 25px;
  background-color: white;
}

.headerBtnBottom {
  width: 40%;
  height: 3px;
  margin-top: 10px;
  background-color: white;
}
.headerBtn {
  font-family: Montserrat;
  padding-right: 16px;
  padding-left: 16px;
  font-size: 14px;
  width: 100px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: #767675;
  cursor: pointer;
  text-decoration: none;
}

.headerBtn h4 {
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  font-weight: normal;
}

.headerBtn.chores {
  padding-left: 0px;
  padding-right: 0px;
}

.route-active.headerBtn {
  color: var(--rentalios-dark);
}
.route-active .headerBtnBottom {
  background-color: var(--rentalios-dark);
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: auto;
  padding-bottom: 12px;
}
.header .headerUserContainer {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
}
.ask-ai-button {
  height: 50px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  border: 1px solid #e2e4e8;
  border-radius: 10px;
  background: #ffffff;
  color: #222222;
  font-family: Montserrat;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}
.ask-ai-button span {
  color: #66a80f;
  font-size: 24px;
  line-height: 1;
}
.headerUserContainer .headerUserDataContainer {
  min-width: 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding-left: 10px;
}
.headerUserContainer .headerUserEmail {
  font-size: 12px;
  line-height: 16px;
  color: #a4a4a4;
}
.headerUserContainer .headerUserName {
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #192a3e;
}
.headerUserContainer .accountImage {
  width: 46px;
  height: 46px;
  border-radius: 25px;
}

.headerUserContainer > img {
  min-width: 46px;
  min-height: 46px;
}

div.header-white-space {
  min-width: 300px;
}

@media only screen and (max-width: 768px) {
  .header .headerUserContainer {
    visibility: hidden;
  }

  .header-wrapper {
    padding-top: unset;
    margin-top: 70px;
  }
  .headerBtn {
    margin-top: 10px;
  }
}
</style>
